import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // applyFirst: [],
    isshowForTaget: false, //忘记密码
    isshowUser: false, //用户协议
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
